'use client'

import { withPostHog } from '@/lib/posthog-client'

export { AnalyticsEvent, type AnalyticsEventName } from './analytics-events'
import type { AnalyticsEventName } from './analytics-events'

// ─────────────────────────────────────────────
// Client-side tracking wrapper
// ─────────────────────────────────────────────
export function trackEvent(
  event: AnalyticsEventName,
  properties?: Record<string, unknown>
) {
  withPostHog((posthog) => posthog.capture(event, properties))
}

// ─────────────────────────────────────────────
// User identification (call after Clerk auth)
// ─────────────────────────────────────────────
export function identifyUser(
  userId: string,
  properties?: Record<string, unknown>
) {
  withPostHog((posthog) => posthog.identify(userId, properties))
}

export function resetUser() {
  withPostHog((posthog) => posthog.reset())
}

// ─────────────────────────────────────────────
// Internal traffic opt-out
// ─────────────────────────────────────────────
const INTERNAL_USER_IDS = (
  process.env.NEXT_PUBLIC_INTERNAL_USER_IDS ?? ''
)
  .split(',')
  .map((id) => id.trim())
  .filter(Boolean)

export function isInternalUser(userId: string): boolean {
  return INTERNAL_USER_IDS.includes(userId)
}

export function optOutIfInternal(userId: string) {
  if (isInternalUser(userId)) {
    withPostHog((posthog) => posthog.opt_out_capturing())
  }
}
